import {applyMiddleware, combineReducers, createStore, Reducer} from 'redux';
import {FormStateMap, reducer as form} from 'redux-form';
import createSagaMiddleware from "redux-saga";
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import {createBrowserHistory} from 'history';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import rootSaga from './sagas/rootSaga';

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

/**
 * Setup and apply all middleware
 */
export const history = createBrowserHistory();
const appRouterMiddleware = routerMiddleware(history);

const sagaMiddleware = createSagaMiddleware();

const getMiddleware = () => {
  return applyMiddleware(appRouterMiddleware, sagaMiddleware);
};

// The top-level state object
export interface ApplicationState {
  form: FormStateMap;
}

/**
 * Root reducer combines all used reducers
 */
const rootReducer: Reducer<ApplicationState> = combineReducers<ApplicationState>({
  form,
});

/**
 * Configure persistence
 */

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['parcelForYou']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

/**
 * Default AppStore
 */
export const AppStore = createStore(
  connectRouter(history)(persistedReducer), composeWithDevTools(getMiddleware())
);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(AppStore);

export default () => {
  return { AppStore, persistor }
}


// WEBPACK FOOTER //
// ./src/redux/AppStore.tsx